'use strict';
import Util from '@common/js/util';

export const INIT_LOADING = 'INIT_LOADING';
export const INIT_ERR = 'INIT_ERR';
export const UPDATE_DETAIL_DATA = 'UPDATE_DETAIL_DATA';
export const UPDATE_NAV_DATA = 'UPDATE_NAV_DATA';

export const FETCH_RES_LOADING = 'FETCH_RES_LOADING';
export const FETCH_RES_SUCC = 'FETCH_RES_SUCC';
export const FETCH_RES_ERR = 'FETCH_RES_ERR';
export const ADD_RES_DATA = 'ADD_RES_DATA';

export const FETCH_USER_LOADING = 'FETCH_USER_LOADING';
export const FETCH_USER_SUCC = 'FETCH_USER_SUCC';
export const FETCH_USER_ERR = 'FETCH_USER_ERR';

export const fetchDetailData = (url, data = {}) => (dispatch) => {
    dispatch({ type: INIT_LOADING });

    // 返回数据一级字段名mapping: [data, msg]; 二级字段名暂时不做处理，请在reducer内处理
    return Util.reqwest(url, data).then((r) => {
        if (r.code == 200) {
            dispatch({
                type: UPDATE_DETAIL_DATA,
                data: r.data.detail
            });
            return Promise.resolve(r);
        } else {
            dispatch({ type: INIT_ERR, msg: r.errorMsg });
            return Promise.reject(r);
        }
    }).catch((e) => {
        dispatch({ type: INIT_ERR });
        return Promise.reject({
            code: 204,
            message: e && e.message || 'something error'
        });
    });
}

// `回应`分页加载
export const fetchResData = (url, data = {}, method = 'GET', validFn = _resultValid) => (dispatch) => {
    dispatch({ type: FETCH_RES_LOADING });

    // 返回数据一级字段名mapping: [data, msg]; 二级字段名暂时不做处理，请在reducer内处理
    return Util.reqwest(url, data).then((r) => {
        if (r.code == 200) {
            if (typeof validFn == 'function' && validFn(r)) {
                dispatch({
                    type: FETCH_RES_SUCC,
                    data: r.data
                });
            }
            return Promise.resolve(r);
        } else {
            dispatch({ type: FETCH_RES_ERR, msg: r.errorMsg });
            return Promise.reject(r);
        }
    }).catch((e) => {
        dispatch({ type: FETCH_RES_ERR });
        return Promise.reject({
            code: 204,
            message: e && e.message || 'something error'
        });
    });
}

export const addResData = (data = {}) => (dispatch) => {
    dispatch({
        type: ADD_RES_DATA,
        data: data
    });
}

export const updateNavData = (data = {}) => (dispatch) => {
    dispatch({
        type: UPDATE_NAV_DATA,
        data: data
    });
}

export const fetchUsersData = (url, data = {}, method = 'GET', validFn = _resultValid) => (dispatch) => {
    dispatch({ type: FETCH_USER_LOADING });

    return Util.reqwest(url, data).then((r) => {
        if (r.code == 200) {
            if (validFn(r)) {
                dispatch({
                    type: FETCH_USER_SUCC,
                    data: r.data
                });
            }
            return Promise.resolve(r);
        } else {
            dispatch({ type: FETCH_USER_ERR, msg: r.errorMsg });
            return Promise.reject(r);
        }
    }).catch((e) => {
        dispatch({ type: FETCH_USER_ERR });
        return Promise.reject({
            code: 204,
            message: e && e.message || 'something error'
        });
    });
}

function _resultValid() {
    return true
}


// WEBPACK FOOTER //
// ./src/redux/action/detail.js